import { Injectable } from "@angular/core";
import { RestClientService } from "src/app/core/services/rest/rest-client.service";
import { TypeDocumentGarantie } from "../model/garanties/type-document-garantie";
import { NatureGarantieChamp } from "../model/garanties/NatureGarantieChamp";
import { ChampSourceGarantie } from "../model/garanties/ChampSourceGarantie";
@Injectable({
  providedIn: "root",
})
export class TypeDocumentChampGarantieService {


  constructor(private _restClientService: RestClientService) {}

  getTypeDocumentGaranties() {
    return this._restClientService.load<TypeDocumentGarantie[]>(
      "types-documents-garanties/list"
    );
  }

  getTypeDocumentGarantieById(id: number) {
    return this._restClientService.load<TypeDocumentGarantie>(
      "types-documents-garanties/get/" + id
    );
  }

  addTypeDocumentGarantie(typeDocument) { 
    return this._restClientService.save<TypeDocumentGarantie>(
      "types-documents-garanties/add",
      typeDocument
    );
  }

  updateTypeDocumentGarantie(typeDocumentId, typeDocument) {
    return this._restClientService.put<TypeDocumentGarantie>(
      `types-documents-garanties/update/${typeDocumentId}`,
      typeDocument
    );
  }

  deleteTypeDocumentGarantie(id: number) {
    return this._restClientService.delete<TypeDocumentGarantie>(
      `types-documents-garanties/delete/${id}`
    );
  }


  //Champs Source garanties
  getChampSourceGaranties() {
    return this._restClientService.load<ChampSourceGarantie[]>(
      "champs-sources-garanties/list"
    );
  }
   //Champs Source non encore utilisés par la natureGarantie
  getEmptyChampSourceGaranties(natureGarantieId: number) {
    return this._restClientService.load<ChampSourceGarantie[]>(
      "champs-sources-garanties/list-empty/" + natureGarantieId
    );
  }
  getChampSourceGarantieById(id: number) {
    return this._restClientService.load<ChampSourceGarantie>(
      "champs-sources-garanties/get/" + id
    );
  }

  addChampSourceGarantie(typeDocument) { 
    return this._restClientService.save<ChampSourceGarantie>(
      "champs-sources-garanties/add",
      typeDocument
    );
  }

  updateChampSourceGarantie(typeDocumentId, typeDocument) {
    return this._restClientService.put<ChampSourceGarantie>(
      `champs-sources-garanties/update/${typeDocumentId}`,
      typeDocument
    );
  }

  deleteChampSourceGarantie(id: number) {
    return this._restClientService.delete<ChampSourceGarantie>(
      `champs-sources-garanties/delete/${id}`
    );
  }


}
